export default __webpack_public_path__ + "static/media/temp-10.59dff0ce.svg";